import { CurrentUserData } from '#/graphql/types';
import { createContext } from 'react';

export interface SessionContextType extends Omit<Partial<CurrentUserData>, '__typename'> {
  loading: boolean;
  error?: unknown;
}

const SessionContext = createContext<SessionContextType>({
  loading: false,
});

export default SessionContext;
